import React from 'react';
import { Mail, Phone, Linkedin } from 'lucide-react';
import { profileData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-amber-400">CA.</span> Sanjay Agrawal
            </h3>
            <p className="text-gray-400 mb-4">
              Senior finance and tax professional with 30+ years of expertise in GST, International Taxation, 
              Transfer Pricing, and FEMA advisory.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" onClick={(e) => scrollToSection(e, '#home')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" onClick={(e) => scrollToSection(e, '#about')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#expertise" onClick={(e) => scrollToSection(e, '#expertise')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Expertise
                </a>
              </li>
              <li>
                <a href="#blogs" onClick={(e) => scrollToSection(e, '#blogs')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Blogs
                </a>
              </li>
              <li>
                <a href="#podcasts" onClick={(e) => scrollToSection(e, '#podcasts')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Podcasts
                </a>
              </li>
              <li>
                <a href="#faqs" onClick={(e) => scrollToSection(e, '#faqs')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  FAQs
                </a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${profileData.email}`}
                  className="flex items-center text-gray-400 hover:text-amber-400 transition-colors"
                >
                  <Mail className="w-5 h-5 mr-2" />
                  {profileData.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${profileData.phone}`}
                  className="flex items-center text-gray-400 hover:text-amber-400 transition-colors"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  {profileData.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} CA. Sanjay Kumar Agrawal. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Chartered Accountant | Cost Accountant | Insolvency Professional
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;